import PersistentUpgradeBanner from './PersistentUpgradeBanner';

export default PersistentUpgradeBanner;
